import { useSelector } from "react-redux";
import CustomButton from "../../../shared/customButton/CustomButton";
import { BASESTORAGE } from "../../../../utils/basestorage";
import LazyLoadImg from "../../../shared/lazyLoadImg/LazyLoadImg";

const LastSlideCategoryHome = ({
  id,
  category,
  icona,
  colore,
  linkCategory,
  routeName,
}) => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  return (
    <div
      className={`lastSlideCategoryHome max-w-xxs sm:max-w-none w-full mx-1 sm:mx-0 lg:mx-3 xl:mx-2 4xl:mx-3 flex flex-col justify-center items-center text-white bg-${colore}`}
    >
      <LazyLoadImg
        imgName={icona?.file_name}
        imgPath={icona?.folder}
        imgWidth="90"
        imgHeight="90"
        imgStyle="filter brightness-0 invert"
        imgAlt={category}
        visibleByDefaultProp={false}
      />
      <span className="titolo text-lg 3xl:text-2xl text-center py-10 block">
        {category}
      </span>
      <CustomButton
        buttonId={id}
        buttonLink={linkCategory}
        buttonRouteName={routeName}
        buttonName={genericheTranslation.veditutti.itemName.toUpperCase()}
        buttonStyle="buttonBorderedTransparent text-white border-white text-center px-5"
      />
    </div>
  );
};

// buttonLink={linkCategory}

export default LastSlideCategoryHome;
